import { z } from 'zod';

/**
 * Schema de validación para Mesas
 */

export const tableSchema = z.object({
  table_number: z
    .string()
    .min(1, 'El número de mesa es requerido')
    .max(20, 'El número de mesa no puede exceder 20 caracteres'),
  name: z
    .string()
    .max(100, 'El nombre no puede exceder 100 caracteres')
    .optional()
    .nullable(),
  capacity: z
    .number()
    .int('La capacidad debe ser un número entero')
    .min(1, 'La capacidad debe ser al menos 1')
    .max(50, 'La capacidad no puede exceder 50')
    .default(4),
  status: z
    .enum(['free', 'occupied', 'reserved', 'maintenance'], {
      errorMap: () => ({ message: 'Estado inválido' }),
    })
    .default('free'),
  location: z
    .string()
    .max(50, 'La ubicación no puede exceder 50 caracteres')
    .optional()
    .nullable(),
  notes: z
    .string()
    .max(500, 'Las notas no pueden exceder 500 caracteres')
    .optional()
    .nullable(),
});

export type TableFormData = z.infer<typeof tableSchema>;
